import router from './router/index';
import store from './store'
import 'mapbox-gl/dist/mapbox-gl.css';

export default {
  router,
  store,
};
